// https://vuex.vuejs.org/en/state.html

export default {
  snackbar: {
    active: false,
    message: '',
    position: 'top right',
    color: 'info',
  },
  drawerSettings: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    // barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    darkMode: false,
    activeColorClass: 'indigo',
    activeDarkText: false,
    activeGroupColor: 'grey',
    mini: false,
  },
  drawer: null,
  contentSettings: {},
}
